import type { Cliente, Pedido, SubPedido } from '../db/tipos'
import { arredondar2 } from '../pedidos/precos'

export type ResumoDeCompras = { ultimaData: string; valorUltima: number; pedidos: number }

// Tela Rota (print dela, 08/10): valor da ultima compra e quantos pedidos o
// cliente fez. "Compra" = pedido FECHADO e vivo -- a mesma regra de
// ultimaCompraPorCliente, que da o selo "Ultima compra ha X dias": se as duas
// discordassem, o card mostraria a data de um pedido e o valor de outro.
// Empresa cancelada ou apagada fica fora do valor.
export function resumoDeCompras(pedidos: Pedido[], subPedidos: SubPedido[]): Map<string, ResumoDeCompras> {
  const valorDoPedido = new Map<string, number>()
  for (const s of subPedidos) {
    if (s.apagado_em !== null || s.status === 'cancelado') continue
    valorDoPedido.set(s.pedido_id, (valorDoPedido.get(s.pedido_id) ?? 0) + s.valor_total)
  }
  const mapa = new Map<string, ResumoDeCompras>()
  for (const p of pedidos) {
    if (p.apagado_em !== null || p.status !== 'fechado') continue
    const atual = mapa.get(p.cliente_id)
    const valor = arredondar2(valorDoPedido.get(p.id) ?? 0)
    if (!atual) mapa.set(p.cliente_id, { ultimaData: p.data, valorUltima: valor, pedidos: 1 })
    else {
      atual.pedidos += 1
      if (p.data > atual.ultimaData) { atual.ultimaData = p.data; atual.valorUltima = valor }
    }
  }
  return mapa
}

// O "Ligar" usa o primeiro contato com telefone. Sem telefone, null: o botao
// nao aparece (um "Ligar" que nao liga e pior que nenhum).
export function linkDeLigar(cliente: Pick<Cliente, 'contatos'>): string | null {
  for (const c of cliente.contatos ?? []) {
    const numero = `${c.ddd ?? ''}${c.telefone ?? ''}`.replace(/\D/g, '')
    if ((c.telefone ?? '').replace(/\D/g, '') !== '') return `tel:${numero}`
  }
  return null
}
